// Test IDs for the Autonomous Blog Writer (Journal automation settings +
// draft review controls) and the desktop Navbar overflow menu.

export const JOURNAL_AUTOMATION = {
  card: 'journal-automation-card',
  statusPill: 'journal-automation-status-pill',
  enableSwitch: 'journal-automation-enable-switch',
  cadenceSelect: 'journal-automation-cadence-select',
  modeSelect: 'journal-automation-mode-select',
  topicQueueTextarea: 'journal-automation-topic-queue-textarea',
  generateNowButton: 'journal-automation-generate-now-button',
  lastRunText: 'journal-automation-last-run-text',
  nextRunText: 'journal-automation-next-run-text',
};

export const ADMIN_JOURNAL_TABLE = {
  root: 'admin-journal-table',
  pendingDraftsBadge: 'admin-nav-journal-pending-drafts-badge',
  statusBadge: (slug) => `journal-post-status-badge-${slug}`,
  publishButton: (slug) => `journal-post-publish-button-${slug}`,
  unpublishButton: (slug) => `journal-post-unpublish-button-${slug}`,
  aiBadge: (slug) => `journal-post-ai-badge-${slug}`,
  suggestCoverButton: 'admin-journal-suggest-cover-button',
  missingCoverHint: (slug) => `journal-post-missing-cover-hint-${slug}`,
};

export const NAVBAR_OVERFLOW = {
  moreTrigger: 'navbar-more-menu-trigger',
  moreItem: (to) => `navbar-more-menu-item-${to}`,
};
